/*=========================================================================================
  File Name: main.js
  Description: main vue(js) file
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import Vue from 'vue'
import App from './App.vue'

// Vuesax Component Framework
import Vuesax from 'vuesax'
import 'material-icons/iconfont/material-icons.css' //Material Icons
import 'vuesax/dist/vuesax.css'
Vue.use(Vuesax)

import ReadMore from 'vue-read-more';

Vue.use(ReadMore);

import HighchartsVue from 'highcharts-vue'
Vue.use(HighchartsVue)
// axios
import axios from "./axios.js"
Vue.prototype.$http = axios

// API Calls
import "./http/requests"

// mock
import "./fake-db/index.js"

// Theme Configurations
import '../themeConfig.js'
import hzqingVueTimeline from 'hzqing-vue-timeline'
Vue.use(hzqingVueTimeline)

import VueTimeline from "@growthbunker/vuetimeline";

Vue.use(VueTimeline);

// Firebase
//import '@/firebase/firebaseConfig'


// Auth0 Plugin
import AuthPlugin from "./plugins/auth";
Vue.use(AuthPlugin);


// ACL
//import acl from './acl/acl'


// Globally Registered Components
import './globalComponents.js'


// Styles: SCSS
import './assets/scss/main.scss'


// Tailwind
import '@/assets/css/main.css'


// Vue Router
import router from './router'


// Vuex Store
import store from './store/store'


// i18n
import i18n from "./i18n/i18n";


// Vuexy Admin Filters
import './filters/filters'


// Clipboard
import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard);


// Tour
import VueTour from 'vue-tour'
Vue.use(VueTour)
require('vue-tour/dist/vue-tour.css')


// VeeValidate
import VeeValidate from 'vee-validate';
Vue.use(VeeValidate);

import VueHorizontalTimeline from "vue-horizontal-timeline";
Vue.use(VueHorizontalTimeline);

// Google Maps
import * as VueGoogleMaps from 'vue2-google-maps'
Vue.use(VueGoogleMaps, {
    load: {
        // Add your API key here
        key: 'YOUR_API_KEY',
        libraries: 'places', // This is required if you use the Auto complete plug-in
    },
})

// Vuejs - Vue wrapper for hammerjs
import { VueHammer } from 'vue2-hammer'
Vue.use(VueHammer)

// PrismJS
import 'prismjs'
import 'prismjs/themes/prism-tomorrow.css'

import "jquery-ui/themes/base/all.css";
import "devextreme/dist/css/dx.common.css";
import "devextreme/dist/css/dx.light.css";
import "@devexpress/analytics-core/dist/css/dx-analytics.common.css";
import "@devexpress/analytics-core/dist/css/dx-analytics.light.css";
import "@devexpress/analytics-core/dist/css/dx-querybuilder.css";
import "devexpress-reporting/dist/css/dx-webdocumentviewer.css";
import "devexpress-reporting/dist/css/dx-reportdesigner.css";
//import  firebase from "firebase";
import { mainSetting } from '@/gloabelConstant.js'


// Feather font icon
require('./assets/css/iconfont.css')
//import './assets/css/iconfont.css';

// Vue select css
// Note: In latest version you have to add it separately
// import 'vue-select/dist/vue-select.css';
// var config = {
//     apiKey: "AIzaSyC45-M6fivH5rarqYzRvU-jXAAvEayR9zs",
//     authDomain: "inclass-299e0.firebaseapp.com",
//     databaseURL: "https://inclass-299e0.firebaseio.com",
//     projectId: "inclass-299e0",
//     storageBucket: "inclass-299e0.appspot.com",
//     messagingSenderId: "709524882544",
//     appId: "1:709524882544:web:469d8da8f32123bf3460b5",
//     measurementId: "G-Y1M87DWHZT"
// };

// firebase.initializeApp(config);
// if(firebase.messaging.isSupported())
// {
// const messaging = firebase.messaging();

// messaging.usePublicVapidKey("BJiuUiQwbyQ0WFdwxnVQWNaPGmUVRZ8trteXeckpAI8p94psXuV5kn5ML-In9Yixahg_cGTeE7ZcAV2eoGmncfY");

// messaging.onMessage((payload) => {
//     
//     console.log('Message received. ', payload);
//     // ...
//   });



// messaging.getToken().then((currentToken) => {
//     
//     if (currentToken) {

//       mainSetting.FCMToken=currentToken;
//       console.log(mainSetting.FCMToken);

//       //this.$router.push( '/pages/login');

//       // sendTokenToServer(currentToken);
//       //updateUIForPushEnabled(currentToken);
//     } else {
//       // Show permission request.
//        console.log('No Instance ID token available. Request permission to generate one.');
//       // Show permission UI.
//       //updateUIForPushPermissionRequired();
//       //setTokenSentToServer(false);
//     }
//   }).catch((err) => {
//     console.log('An error occurred while retrieving token. ', err);
//    // showToken('Error retrieving Instance ID token. ', err);
//     //setTokenSentToServer(false);
//   });
// }

Vue.config.productionTip = false

new Vue({
  router,
  store,
  i18n,
  //acl,
  render: h => h(App)
}).$mount('#app')
